import User from 'src/models/User'
import GlobalMixin from 'src/helpers/GlobalMixins'

let user = new User()
const routesBeforeEach = (to, from, next) => {
  if (user.isUserAuth() === false) {
    user = new User()
  }
  if (user.isUserAuth() || to.path === '/login') {
    if ((to.path === '/panel/wplaty' || to.path === '/panel/statystyki-deklaracji') && GlobalMixin.methods.getPermission('hideAmounts')) {
      next({
        path: '/panel/uruchomienia-wypelnienia'
      })
    } else {
      next()
    }
  } else {
    next({
      path: '/login'
    })
  }
}
export default routesBeforeEach



// WEBPACK FOOTER //
// ./src/routes/beforeEach.js